import { ITicketData } from '@/types';
import UserProfile from '../../Users/UserProfile';

export default function UserTicket({ ticket }: { ticket: ITicketData }) {


  return <UserProfile userId={ticket.reported_user?.reported_id} />;
}
